/**
 * Depth media reused below the hero.
 *
 * Every path here points at a cinematic asset that was already rendered into
 * `public/` for the hero sequence, so the page keeps one continuous atmosphere
 * instead of dropping into flat black after the hero. Nothing new is generated.
 */

/** Decorative full-bleed backdrops. Skipped under Save-Data; they carry no information. */
export const ATMOSPHERE_PLATES = {
  operations: {
    desktop: '/cinematic/revision-02/desktop/poster.webp',
    portrait: '/cinematic/revision-02/portrait/poster.webp',
  },
  output: {
    desktop: '/cinematic/revision-02/desktop/frames/frame-0218.webp',
    portrait: '/cinematic/revision-02/portrait/frames/frame-0073.webp',
  },
} as const;

export type AtmospherePlateId = keyof typeof ATMOSPHERE_PLATES;

/** Focal proof imagery. These carry meaning, so they load regardless of Save-Data. */
export const PROOF_PLATES = {
  connectedWorkflow: {
    src: '/cinematic/revision-02/desktop/frames/frame-0075.webp',
    alt: 'An operations screen running one connected workflow, with finished steps marked complete and the next step still in progress',
  },
  verifiedOutput: {
    src: '/cinematic/revision-02/desktop/frames/frame-0218.webp',
    alt: 'Completed paperwork stacked in an output tray beside a screen of checked-off operational records',
  },
} as const;

export type ProofPlateId = keyof typeof PROOF_PLATES;
